import React from 'react';
import { useIsFetching } from '@tanstack/react-query';
import styles from '../_pages/PreviousImages/v2/PreviousImages.module.scss';
import Spinner from '../Spinner';
import PastImageItems from './PastImageItems';

export default function PastImagesContent({ onContinue, student, query = {} }) {
  const headerText = `Complete your collection of ${student.firstName}'s school pictures.`;

  const isFetching = useIsFetching();

  if (isFetching) return <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}><Spinner color='blue' /></div>;

  return (
    <>
      <h1 className={styles.header}>
        <span>Don't miss a single memory</span>
      </h1>
      <p className={styles.saleblue}>SAVE ON PICTURES FROM PREVIOUS SCHOOL YEARS!</p>
      <h2 className={styles.sale}><span>{headerText}</span></h2>
      
      
      <div className={styles.grid}>
        <PastImageItems
          student={student}
          onContinue={onContinue}
          query={query}
        />
      </div>
    </>
  );
}
